/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { ArrowIcon } from "ui/ArrowIcon";

import type { FC } from "react";

export const BackButton: FC<{
  isDarkMode: boolean;
  handleBackButton: () => void;
}> = ({ isDarkMode, handleBackButton }) => {
  const { t } = useI18n();

  return (
    <div
      css={css`
        display: flex;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
        `}
        onClick={handleBackButton}
      >
        <ArrowIcon
          css={css`
            width: 16px;
            height: auto;
            fill: ${isDarkMode ? "#fff" : "#000"};
          `}
        />
        <div
          css={css`
            color: ${isDarkMode ? "#fff" : "#000"};
            font-size: 14px;
          `}
        >
          {t("streaming.commerceModal.backButton")}
        </div>
      </div>
    </div>
  );
};
